export default {
  // Search inputs
  keywordPlaceholder: 'Please enter keyword',
  alarmTypePlaceholder: 'Please select alarm type',
  startTimePlaceholder: 'Start Time',
  endTimePlaceholder: 'End Time',

  // Buttons
  query: 'Search',
  table: 'Table',
  card: 'Card',

  // Alarm type options
  normal: 'Normal',
  falseAlarm: 'False Alarm',

  // Table column headers
  alarmType: 'Alarm Type',
  alarmTime: 'Alarm Time',
  alarmImage: 'Alarm Image',
  alarmVideo: 'Alarm Video',
  operation: 'Operation',

  // Card labels
  alarmTypeLabel: 'Alarm Type:',
  alarmTimeLabel: 'Alarm Time:',
  alarmImageLabel: 'Alarm Image:',

  // Empty states
  noAlarmData: 'No alarm data',

  // Video related
  alarmVideoTitle: 'Alarm Video',
  screenshotFileName: 'Screenshot',

  // Messages
  markAsFalseAlarmTitle: 'Mark this image as false alarm?',
  markSuccess: 'Marked successfully',
  executeSuccess: 'Executed successfully',

  map: {
    currentWaypoint: 'Current Waypoint:',
    waypointSegment: 'Waypoint Segment',
    algorithmName: 'Algorithm Name',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    view: 'View',
    aiCompareVideo: 'AI Comparison Video',
    watermarkDrone: 'Aircraft',
    watermarkAlgorithm: 'Algorithm',
    loading: 'Loading',
    fullscreen: 'Fullscreen',
    streamQuality: {
      auto: 'Auto',
      smooth: 'Smooth',
      standard: 'Standard',
      hd: 'HD',
      uhd: 'UHD',
    },
  },

  // Algorithm Project Management Page
  project: {
    projectArea: 'Project Area',
    pleaseSelectMenu: 'Please select superior menu',
    configureAlgorithmLibrary: 'Configure Algorithm Library',
    addProjectAlgorithmBinding: 'Add Project-Algorithm Binding',
    modelSelection: 'Model Selection',
    unselectedModels: 'Unselected Models',
    selectedModels: 'Selected Models',
    cancel: 'Cancel',
    confirm: 'Confirm',
    projectName: 'Project Name',
    bindingCode: 'Binding Code',
    projectDescription: 'Project Description',
    createTime: 'Creation Time',
    operation: 'Operation',
    addSuccess: 'Added successfully',
    modifySuccess: 'Modified successfully',
  },
}